import { render, staticRenderFns } from "./TicketsDetails.vue?vue&type=template&id=419ba4ec"
import script from "./TicketsDetails.vue?vue&type=script&lang=js"
export * from "./TicketsDetails.vue?vue&type=script&lang=js"
import style0 from "./TicketsDetails.vue?vue&type=style&index=0&id=419ba4ec&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports